import { PrinterOutlined } from "@ant-design/icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Button, Input, message, Modal, Select } from "antd";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import LoadingBox from "../../Components/LoadingBox";
import { API, Headers } from "../../Config";
import { GET } from "../../Config/ApiRequests";
import countries from "../../Config/countryCode.json";
import PageHeader from "../../Routes/PageHeader";
import SalesDataTable from "./dataTable";
import SalesExpenceTable from "./expenseTable";
import MenuBarSales from "./menuBar";
import PendingRecieptDataTable from "./recieptTable";
import SalesProductTable from "./sales-product-table";
import "./style.css";

const SalesReport = () => {
  const Auth = useSelector((state) => state.Auth.user);
  const [loading, setLoading] = useState(false);
  const [openingBalance, setOpeningBalance] = useState();
  const [data, setData] = useState({ paidBoxes: [], pendingBoxes: [] });
  const [totals, setTotals] = useState({});
  const [expense, setExpenses] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [multipleOpeningBalance, setMultipleOpeningBalance] = useState();
  const [pageConfig, setPageConfig] = useState({ page: 1, take: 10 });
  const [meta, setMeta] = useState({});
  const [dateFrom, setDateFrom] = useState(moment().format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [search, setSearch] = useState([Auth?.id?.toString()]);
  const [allUsers, setAllUsers] = useState([]);
  const [expanded, setExpanded] = useState(["panel1"]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPrinting, setIsPrinting] = useState(false);
  const [holdAmount, setHoldAmount] = useState(0);
  const [isUserSelected, setIsUserSelected] = useState(false);
  const [isWhatsAppModalVisible, setIsWhatsAppModalVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [transactionRequestAmount, setTransactionRequestedAmount] = useState(0);
  const [countryCode, setCountryCode] = useState("+966");
  const [countrySearchQuery, setCountrySearchQuery] = useState("");
  const [filteredCountries, setFilteredCountries] = useState(
    countries.countries
  );
  const componentRef = useRef();

  const totalExpense = expense.reduce(
    (sum, item) => sum + parseFloat(item.amount || 0),
    0
  );
  const closingBalance = parseFloat(totals.totalPaid || 0) - totalExpense;
  // const cashInHand = parseFloat(totals.totalPaidCash || 0) - totalExpense;
  const totalCashInHand = transactionRequestAmount;

  const fetchAllData = useCallback(
    async (params = {}) => {
      const {
        page = pageConfig.page,
        take = pageConfig.take,
        from = dateFrom,
        to = dateTo,
        searchIds = search,
      } = params;
      if (!searchIds || searchIds.length === 0 || !from || !to || loading)
        return;
      setLoading(true);
      try {
        const userDataUrl = `${API.BASR_URL}${
          API.BOXES_VIA_BRANCH_BY_BOXDETAILS
        }${Number(
          Auth?.id
        )}?order=DESC&page=${page}&take=${take}&dateFrom=${from}&dateTo=${to}&search=${searchIds.join(
          ","
        )}`;
        const userDataResponse = await axios.get(userDataUrl, {
          headers: Headers(),
        });
        if (userDataResponse.status === 200) {
          setData(userDataResponse?.data?.data);
          setTotals(userDataResponse?.data?.totals);
          setOpeningBalance(userDataResponse?.data?.openingBalance);
          setMeta(userDataResponse?.data?.meta);
        }

        const expenseUrl = `${
          API.BASR_URL
        }expance_entry/byUser?order=DESC&page=1&take=50&userIds=${searchIds.join(
          ","
        )}&dateFrom=${from}&dateTo=${to}`;
        const expenseResponse = await fetch(expenseUrl, {
          method: "GET",
          headers: Headers(),
        });
        if (expenseResponse.ok) {
          const expenseData = await expenseResponse.json();
          setExpenses(
            expenseData?.data?.filter((item) => item?.ispaid === false)
          );
        }

        const salesUrl = `${API.BASR_URL}sale/by-users`;
        const salesResponse = await fetch(salesUrl, {
          method: "POST",
          headers: Headers(),
          body: JSON.stringify({
            userIds: searchIds.map(Number),
            startDate: from,
            endDate: to,
          }),
        });
        const salesResult = await salesResponse.json();
        const salesDetails = salesResult?.data?.flatMap((sale) =>
          sale.saleDetails.map((detail) => ({
            ...detail,
            user: sale.userDetails,
            created_at: sale.created_at,
            status:
              detail.total === detail.paid_amount + detail.discount
                ? "Paid"
                : detail.paid_amount + detail.discount > 0 &&
                  detail.paid_amount + detail.discount < detail.total
                ? "Partial"
                : "Not Paid",
            totalPaidAmount: detail.paid_amount + detail.discount,
            totalAmount: detail.total,
            discount: detail.discount,
          }))
        );
        setSalesData(salesDetails || []);

        if (searchIds?.length > 0) {
          const accountIds = [];
          if (searchIds?.length > 0) {
            for (const userId of searchIds) {
              // Fetch account ID for the current user
              const accountResponse = await fetch(
                `${API.BASR_URL}${API.GET_USER_ACCOUNTS}${userId}`,
                {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                }
              );
              const accountData = await accountResponse.json();
              const accountId = accountData?.data;
              if (
                accountId &&
                Array.isArray(accountId) &&
                accountId.length > 0
              ) {
                accountIds.push(accountId[0]);
              }
            }
          }
          if (accountIds?.length > 0) {
            const balanceUrl = `${API.BASR_URL}${API.GETBALANCEDRIVERSBYMULTIPLE}`;
            const balanceResponse = await fetch(balanceUrl, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ accountNumber: accountIds, from, to }),
            });
            if (balanceResponse.ok) {
              const balanceResult = await balanceResponse.json();
              setHoldAmount(balanceResult?.data?.balance || 0);
            }
            const openingBalanceUrl = `${API.BASR_URL}${API.GETOPENINGBALANCEBYDRIVER}`;
            const openingbalanceResponse = await fetch(openingBalanceUrl, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                account_no: accountIds,
                date_from: from,
              }),
            });
            const openingbalanceResponseqq =
              await openingbalanceResponse?.json();
            setMultipleOpeningBalance(openingbalanceResponseqq?.totalAmount);

            const pendingUrl = `${API.BASR_URL}${
              API.GET_USER_PENDING_TRANSACTION_REQUEST
            }${
              Auth?.id === 1 ? Auth?.id : accountIds
            }?dateFrom=${from}&dateTo=${to}`;
            const pendingResponse = await fetch(pendingUrl, {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            });
            if (pendingResponse.ok) {
              const pendingData = await pendingResponse.json();
              setTransactionRequestedAmount(
                parseFloat(pendingData?.data?.transactions || 0)
              );
            }
          }
        }
      } catch (error) {
        message.error("Failed to load data");
      } finally {
        setLoading(false);
      }
    },
    [
      Auth.id,
      pageConfig.page,
      pageConfig.take,
      dateFrom,
      dateTo,
      search,
      loading,
    ]
  );

  const handleChange = useCallback(
    (panel) => (event, isExpanded) => {
      setExpanded((prev) =>
        isExpanded ? [...prev, panel] : prev.filter((item) => item !== panel)
      );
    },
    []
  );

  const handleBeforePrint = useCallback(() => {
    setIsPrinting(true);
    setExpanded(["panel1", "panel2", "panel3", "panel4"]);
    return new Promise((resolve) => setTimeout(resolve, 500));
  }, []);

  const handleAfterPrint = useCallback(() => {
    setIsPrinting(false);
    setExpanded(["panel1"]);
  }, []);

  const handleCountrySearch = (value) => {
    setCountrySearchQuery(value);
    setFilteredCountries(
      value.trim() === ""
        ? countries.countries
        : countries.countries.filter(
            (country) =>
              country.name.toLowerCase().includes(value.toLowerCase()) ||
              country.code.toLowerCase().includes(value.toLowerCase())
          )
    );
  };

  const generatePDF = async () => {
    const { paidBoxes, pendingBoxes } = data;
    const totalExpenseFormatted = totalExpense.toFixed(2);
    const totalSalesAmount = salesData
      .reduce((acc, item) => acc + parseFloat(item.totalAmount || 0), 0)
      .toFixed(2);

    const sections = [
      {
        html: `
          <div style="text-align: center; margin-bottom: 15px;">
            <div style="font-size: 16px; font-weight: bold;">SAHARI CARGO AND COURIER</div>
            <div style="font-size: 12px;">${reportTitle}</div>
          </div>
        `,
      },
      {
        html: `
          <div style="font-size: 12px; font-weight: bold; margin-top: 15px; margin-bottom: 5px;">
            Pending Payment Boxes (${pendingBoxes?.length})
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
            <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Box No</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Charge (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Discount (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Paid (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Balance (SAR)</th>
              </tr>
            </thead>
            <tbody>
              ${pendingBoxes
                .map(
                  (box) => `
                <tr>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    box?.box_number
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.totalCharge.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">0.00</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">0.00</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.totalCharge.toFixed(
                    2
                  )}</td>
                </tr>
              `
                )
                .join("")}
              <tr style="font-weight: bold; background-color: #e6e6e6;">
                <td colspan="4" style="border: 1px solid #000; padding: 5px; text-align: left;">Total Pending</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                  totals.totalPending || "0.00"
                }</td>
              </tr>
            </tbody>
          </table>
        `,
      },
      {
        html: `
          <div style="font-size: 12px; font-weight: bold; margin-top: 15px; margin-bottom: 5px;">
            Paid Boxes (${paidBoxes?.length})
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
            <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Box No</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Box ID</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Service</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Charge (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Discount (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Paid (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Cash (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Bank (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Balance (SAR)</th>
              </tr>
            </thead>
            <tbody>
              ${paidBoxes
                .map(
                  (box) => `
                <tr>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    box?.box_number
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    box?.collection_id
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    box?.service?.name
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.totalCharge.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.totalDiscount.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.totalPaid.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.boxPaidCash.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.boxPaidBank.toFixed(
                    2
                  )}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${box?.balance.toFixed(
                    2
                  )}</td>
                </tr>
              `
                )
                .join("")}
              <tr style="font-weight: bold; background-color: #e6e6e6;">
                <td colspan="6" style="border: 1px solid #000; padding: 5px; text-align: left;">Total Paid (Cash: ${
                  totals.totalPaidCash || "0.00"
                }, Bank: ${totals.totalPaidBank || "0.00"})</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                  totals.totalPaid || "0.00"
                }</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;"></td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;"></td>
              </tr>
            </tbody>
          </table>
        `,
      },
      {
        html: `
          <div style="font-size: 12px; font-weight: bold; margin-top: 15px; margin-bottom: 5px;">
            Expenses (${expense?.length})
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
            <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Description</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Amount (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Paid (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Balance (SAR)</th>
              </tr>
            </thead>
            <tbody>
              ${expense
                .map(
                  (item) => `
                <tr>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    item?.head
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${parseFloat(
                    item?.amount || 0
                  ).toFixed(2)}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">0.00</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${parseFloat(
                    item?.amount || 0
                  ).toFixed(2)}</td>
                </tr>
              `
                )
                .join("")}
              <tr style="font-weight: bold; background-color: #e6e6e6;">
                <td colspan="3" style="border: 1px solid #000; padding: 5px; text-align: left;">Total Expense</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">${totalExpenseFormatted}</td>
              </tr>
            </tbody>
          </table>
        `,
      },
      {
        html: `
          <div style="font-size: 12px; font-weight: bold; margin-top: 15px; margin-bottom: 5px;">
            Sales Products (${salesData?.length})
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
            <thead>
              <tr style="background-color: #f2f2f2;">
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Name</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Description</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Total Amount (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Total Paid Amount (SAR)</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Status</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">User</th>
                <th style="border: 1px solid #000; padding: 5px; text-align: left; font-weight: bold;">Created At</th>
              </tr>
            </thead>
            <tbody>
              ${salesData
                .map(
                  (item) => `
                <tr>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    item?.name
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    item?.description
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${parseFloat(
                    item?.totalAmount || 0
                  ).toFixed(2)}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${parseFloat(
                    item?.totalPaidAmount || 0
                  ).toFixed(2)}</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    item?.status
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${
                    item?.user?.name
                  }</td>
                  <td style="border: 1px solid #000; padding: 5px; text-align: left;">${moment(
                    item?.created_at
                  ).format("YYYY-MM-DD")}</td>
                </tr>
              `
                )
                .join("")}
              <tr style="font-weight: bold; background-color: #e6e6e6;">
                <td colspan="6" style="border: 1px solid #000; padding: 5px; text-align: left;">Total Sales Amount</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">${totalSalesAmount}</td>
              </tr>
            </tbody>
          </table>
        `,
      },
      {
        html: `
          <div style="font-size: 12px; font-weight: bold; margin-top: 15px; margin-bottom: 5px;">
            Summary
          </div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 10px;">
            <tbody>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left; width: 70%;">Total Box Amount</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalBoxCharge || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Receipt Amount</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalPaid || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Paid Cash</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalPaidCash || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Paid Bank</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalPaidBank || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Discount</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalDiscount || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Outstanding</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${
                  totals.totalBalance || "0.00"
                } SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Expense</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${totalExpenseFormatted} SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Transaction Request Amount</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${transactionRequestAmount.toFixed(
                  2
                )} SAR</td>
              </tr>
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Closing Balance</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${closingBalance.toFixed(
                  2
                )} SAR</td>
              </tr>
            
        ${
          typeof openingBalance === "number" &&
          !isNaN(openingBalance) &&
          openingBalance > 0
            ? `
      <tr>
        <td style="border: 1px solid #000; padding: 5px; text-align: left;">Opening Balance</td>
        <td style="border: 1px solid #000; padding: 5px; text-align: right;">${openingBalance.toFixed(
          2
        )} SAR</td>
      </tr>
    `
            : ""
        }
            
              <tr>
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Closing Balance</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${holdAmount.toFixed(
                  2
                )} SAR</td>
              </tr>
              <tr style="background-color: #d9edf7; font-weight: bold;">
                <td style="border: 1px solid #000; padding: 5px; text-align: left;">Total Cash in Hand</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">${(
                  totalCashInHand +
                  parseFloat(holdAmount || 0) 
                ).toFixed(2)} SAR</td>
              </tr>
            </tbody>
          </table>
        `,
      },
    ];

    const pdfWidth = 595;
    const pdfHeight = 842;
    const margin = 20;
    const contentWidth = pdfWidth - 2 * margin;
    const pdf = new jsPDF("p", "pt", "a4");
    let currentY = margin;

    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.width = `${contentWidth}px`;
    tempDiv.style.fontFamily = "Arial, sans-serif";
    document.body.appendChild(tempDiv);

    for (const section of sections) {
      tempDiv.innerHTML = section.html;

      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        width: contentWidth,
        windowWidth: contentWidth,
        scrollY: -window.scrollY,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png", 0.8);
      const imgProps = pdf.getImageProperties(imgData);
      const sectionHeight = (imgProps.height * contentWidth) / imgProps.width;

      if (currentY + sectionHeight > pdfHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        currentY,
        contentWidth,
        sectionHeight
      );
      currentY += sectionHeight + 10;
    }

    document.body.removeChild(tempDiv);
    return pdf;
  };

  const handleWhatsAppShare = async () => {
    try {
      setLoading(true);
      const pdf = await generatePDF();
      const pdfBlob = pdf.output("blob");
      const pdfFile = new File(
        [pdfBlob],
        `SalesReport_${moment().unix()}.pdf`,
        { type: "application/pdf" }
      );

      const phone = `${countryCode}${phoneNumber}`.trim();
      if (!phone.match(/^\+\d{10,15}$/)) {
        throw new Error("Invalid phone number. Please enter a valid number.");
      }
      const sanitizedPhone = "+" + phone.replace(/\D/g, "");
      const caption = `Here's the Sales Report PDF for ${reportTitle}`;

      const formData = new FormData();
      formData.append("number", sanitizedPhone);
      formData.append("caption", caption);
      formData.append("file", pdfFile);
      formData.append("box", "SALESREPORT ");

      const response = await fetch(
        "https://sahari-messageing-server.bairuhatech.com/sendPdf",
        {
          method: "POST",
          body: formData,
        }
      );

      const responseText = await response.text();
      if (!response.ok)
        message.error(
          `Server error: ${response.status} - ${
            responseText || "Unknown error"
          }`
        );

      if (responseText === "PDF sent successfully") {
        message.success("PDF sent successfully via WhatsApp!");
        setIsWhatsAppModalVisible(false);
        setPhoneNumber("");
        setCountryCode("+966");
        setCountrySearchQuery("");
        setFilteredCountries(countries.countries);
      } else {
        throw new Error(responseText || "Failed to send PDF");
      }
    } catch (error) {
      console.log("error ==>");
      console.log(error);
      console.log("error ==>");
      message.error(
        error.message || "Failed to send via WhatsApp. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const onFinish = useCallback(
    async (values) => {
      const from = values?.dateFrom || moment().format("YYYY-MM-DD");
      const to = values?.dateTo || moment().format("YYYY-MM-DD");
      const searchIds =
        values?.user_ids.length > 0 ? values.user_ids : [Auth?.id?.toString()];
      setIsUserSelected(searchIds.length > 0);
      setSearch(searchIds);
      setDateFrom(from);
      setDateTo(to);
      setPageConfig((prev) => ({ ...prev, page: 1 }));
      await fetchAllData({
        page: 1,
        take: pageConfig.take,
        from,
        to,
        searchIds,
      });
    },
    [Auth.id, pageConfig.take, fetchAllData]
  );

  const pagination = useCallback(
    async (newPage, newTake) => {
      if (newPage !== pageConfig.page || newTake !== pageConfig.take) {
        setPageConfig({ page: newPage, take: newTake });
        await fetchAllData({
          page: newPage,
          take: newTake,
          from: dateFrom,
          to: dateTo,
          searchIds: search,
        });
      }
    },
    [dateFrom, dateTo, search, fetchAllData, pageConfig]
  );

  const fetchInitialData = useCallback(async () => {
    try {
      setLoading(true);
      const users = await GET(
        `${API.ALL_USERS_BY_BRANCH}${Auth?.id}/${Auth?.branch_id}`
      );
      setAllUsers(users?.data || []);
      const defaultDate = moment().format("YYYY-MM-DD");
      setDateFrom(defaultDate);
      setDateTo(defaultDate);
      setSearch([Auth?.id?.toString()]);
      await fetchAllData({
        page: 1,
        take: pageConfig.take,
        from: defaultDate,
        to: defaultDate,
        searchIds: [Auth?.id?.toString()],
      });
    } catch (error) {
      message.error("Failed to load initial data");
    } finally {
      setLoading(false);
    }
  }, [Auth?.id, Auth?.branch_id, pageConfig.take, fetchAllData]);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const formatCurrency = (value) => parseFloat(value || 0).toFixed(2);
  const selectedUsers = allUsers.filter((user) =>
    search.includes(user.id.toString())
  );
  const isDateRange = dateFrom !== dateTo;
  const reportTitle =
    isUserSelected && selectedUsers.length > 0
      ? `Daily Closing Report By: ${selectedUsers
          .map((u) => u.name)
          .join(", ")} - ${isDateRange ? `${dateFrom} to ${dateTo}` : dateFrom}`
      : `Daily Closing Report - ${
          isDateRange ? `${dateFrom} to ${dateTo}` : dateFrom
        }`;

  return (
    <div>
      <PageHeader PageName="Report" breadScrum="Admin / Report / Sales" />
      <MenuBarSales
        onFinish={onFinish}
        allUsers={allUsers}
        handleOnchange={setSearch}
      />
      <div className="text-end no-print">
        <ReactToPrint
          trigger={() => (
            <Button
              size="small"
              type="primary"
              icon={<PrinterOutlined />}
              style={{ marginLeft: 8 }}
            >
              Print Statement
            </Button>
          )}
          content={() => componentRef.current}
          onBeforeGetContent={handleBeforePrint}
          onAfterPrint={handleAfterPrint}
        />
        <Button
          size="small"
          type="primary"
          icon={<PrinterOutlined />}
          style={{ marginLeft: 8 }}
          onClick={() => setIsWhatsAppModalVisible(true)}
        >
          Share via WhatsApp
        </Button>
      </div>
      <Modal
        title="Share via WhatsApp"
        visible={isWhatsAppModalVisible}
        onCancel={() => {
          setIsWhatsAppModalVisible(false);
          setPhoneNumber("");
          setCountryCode("+966");
          setCountrySearchQuery("");
          setFilteredCountries(countries.countries);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsWhatsAppModalVisible(false);
              setPhoneNumber("");
              setCountryCode("+966");
              setCountrySearchQuery("");
              setFilteredCountries(countries.countries);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="share"
            type="primary"
            onClick={handleWhatsAppShare}
            disabled={loading}
            loading={loading}
          >
            Share
          </Button>,
        ]}
      >
        <p>
          Select country code and enter phone number to share the report as a
          PDF.
        </p>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 16 }}
        >
          <Select
            showSearch
            style={{ width: 120, marginRight: 8 }}
            value={countryCode}
            onChange={setCountryCode}
            onSearch={handleCountrySearch}
            filterOption={false}
            notFoundContent={null}
          >
            {filteredCountries.map((country) => (
              <Select.Option key={country.code} value={country.code}>
                {country.name} ({country.code})
              </Select.Option>
            ))}
          </Select>
          <Input
            placeholder="Enter phone number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ flex: 1 }}
          />
        </div>
      </Modal>

      <div className="d-flex justify-content-end p-3" />
      {loading ? (
        <LoadingBox />
      ) : (
        <div ref={componentRef} className="p-3">
          <div className="print-header">SAHARI CARGO AND COURIER</div>
          <div className="my-3 report-title">
            <strong>{reportTitle}</strong>
          </div>

          <Accordion
            expanded={expanded.includes("panel1") || isPrinting}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand_icon" />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className="new-collection-form-txt1">
                Pending Payment Boxes Details
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <PendingRecieptDataTable
                data={data.pendingBoxes}
                PageOnchange={pagination}
                meta={meta}
                onSelect={setSelectedRows}
              />
              <div className="mt-3">
                Total Pending Box Amount: {formatCurrency(totals.totalPending)}{" "}
                SAR
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded.includes("panel2") || isPrinting}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand_icon" />}
              aria-controls="panel2bh-content"
              id="panel1bh-header"
            >
              <div className="new-collection-form-txt1">
                Paid Payment Boxes Details
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <SalesDataTable
                data={data.paidBoxes}
                PageOnchange={pagination}
                meta={meta}
                onSelect={setSelectedRows}
              />
              <div className="mt-3">
                Total Paid Box Amount: {formatCurrency(totals.totalPaid)} SAR
              </div>
              <div>
                Total Paid Cash: {formatCurrency(totals.totalPaidCash)} SAR
              </div>
              <div>
                Total Paid Bank: {formatCurrency(totals.totalPaidBank)} SAR
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded.includes("panel3") || isPrinting}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand_icon" />}
              aria-controls="panel2bh-content"
              id="panel1bh-header"
            >
              <div className="new-collection-form-txt1">
                Sales Products Details
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <SalesProductTable
                data={salesData}
                PageOnchange={pagination}
                meta={meta}
                onSelect={setSelectedRows}
              />
              <div className="mt-3">
                Total Sales Amount:{" "}
                {formatCurrency(
                  salesData.reduce(
                    (acc, item) => acc + parseFloat(item.totalAmount || 0),
                    0
                  )
                )}{" "}
                SAR
              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded.includes("panel4") || isPrinting}
            onChange={handleChange("panel4")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand_icon" />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className="new-collection-form-txt1">Expense Details</div>
            </AccordionSummary>
            <AccordionDetails>
              <SalesExpenceTable expense={expense} />
              <div className="mt-3">
                Total Expense: {formatCurrency(totalExpense)} SAR
              </div>
            </AccordionDetails>
          </Accordion>

          <br />
          <Accordion
            expanded={expanded.includes("panel5") || isPrinting}
            onChange={handleChange("panel5")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand_icon" />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div className="new-collection-form-txt1">Summary Details</div>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                Total Box Charge: {formatCurrency(totals.totalBoxCharge)} SAR
              </div>
              <div>
                Total Paid Box Amount: {formatCurrency(totals.totalPaid)} SAR
              </div>
              <div>
                Total Paid Box Cash Amount:{" "}
                {formatCurrency(totals.totalPaidCash)} SAR
              </div>
              <div>
                Total Paid Box Bank Amount:{" "}
                {formatCurrency(totals.totalPaidBank)} SAR
              </div>
              <div>
                Total Pending Box Amount: {formatCurrency(totals.totalPending)}{" "}
                SAR
              </div>
              <div>
                Total Outstanding Box Amount:{" "}
                {formatCurrency(totals.totalBalance)} SAR
              </div>
              <div>
                Total Discount Box Amount:{" "}
                {formatCurrency(totals.totalDiscount)} SAR
              </div>
              <div>Total Expense: {formatCurrency(totalExpense)} SAR</div>
              <div>
                Transaction Request Amount:{" "}
                {formatCurrency(transactionRequestAmount)} SAR
              </div>
              <div>
                {" "}
                <b>Opening Balance: </b>{" "}
                {formatCurrency(multipleOpeningBalance)} SAR
              </div>
              <div> <b>Closing Balance: </b> {formatCurrency(holdAmount || 0)} SAR</div>

              {/* <div>
                <strong>
                  Holded Amount: {formatCurrency(holdAmount || 0)} SAR
                </strong>
              </div> */}
              <hr />
              <div className="sales-report-bottontext">
                <strong>
                  Total Cash in Hand:{" "}
                  {(Number(totalCashInHand) + Number(holdAmount || 0)).toFixed(
                    2
                  )}{" "}
                  SAR
                </strong>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default React.memo(SalesReport);
